import App from "./App";
import { Logtail } from "@logtail/browser";
import React from "react";
import ReactDOM from "react-dom";

export const logtail = new Logtail("2BWsk3cqCkxegVeQhgBkHTkm");

ReactDOM.render(<App />, document.getElementById("root"));
